// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стили для слайдера */
.slick-dots {
  bottom: 180px;
}

.slick-dots li button:before {
  font-family: "slick", sans-serif;
  font-size: 9px;
  line-height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  content: "•";
  text-align: center;
  opacity: 0.5;
  color: white;
  -webkit-font-smoothing: antialiased;
}

.slick-dots li.slick-active button:before {
  opacity: 0.75;
  color: rgb(0, 183, 255);
}

/* Унифицированные стили для textarea */
.textarea--akte {
  width: 100%;
  background-color: rgb(0, 0, 0);
  color: white;
  font-size: 18px;
  line-height: 25px;
  font-weight: 400;
  font-family: "inter", sans-serif;
  resize: none;
  text-align: center;
  overflow: hidden;
  margin-bottom: 20px;
  padding-top: 17px; /* Переносим padding-top сюда, чтобы избежать дублирования */
  transition: background-color 0.3s ease, color 0.3s ease; /* Для плавных изменений */
}

/* Активное состояние textarea */
.textarea--akte.active {
  background-color: #141414;
}

/* Стили для disabled textarea */
textarea[disabled] {
  color: #ffffff;
}

/* Стили для слайдера */
.swiper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.radioText {
  font-size: 18px !important;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
}

.swiper-pagination {
  position: absolute;
  bottom: 20px; /* Вместо margin-top используем bottom для более гибкой настройки */
  display: flex;
  justify-content: center;
  width: 100%;
}

.swiper-pagination-bullet-active {
  background-color: rgb(0, 183, 255);
}

/* Стили для slick */
.slick-dots {
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Akte/style.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB,EAAE,4DAA4D;EAC/E,uDAAuD,EAAE,0BAA0B;AACrF;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,mEAAmE;EACjF,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;AACzB","sourcesContent":["/* Стили для слайдера */\n.slick-dots {\n  bottom: 180px;\n}\n\n.slick-dots li button:before {\n  font-family: \"slick\", sans-serif;\n  font-size: 9px;\n  line-height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  content: \"•\";\n  text-align: center;\n  opacity: 0.5;\n  color: white;\n  -webkit-font-smoothing: antialiased;\n}\n\n.slick-dots li.slick-active button:before {\n  opacity: 0.75;\n  color: rgb(0, 183, 255);\n}\n\n/* Унифицированные стили для textarea */\n.textarea--akte {\n  width: 100%;\n  background-color: rgb(0, 0, 0);\n  color: white;\n  font-size: 18px;\n  line-height: 25px;\n  font-weight: 400;\n  font-family: \"inter\", sans-serif;\n  resize: none;\n  text-align: center;\n  overflow: hidden;\n  margin-bottom: 20px;\n  padding-top: 17px; /* Переносим padding-top сюда, чтобы избежать дублирования */\n  transition: background-color 0.3s ease, color 0.3s ease; /* Для плавных изменений */\n}\n\n/* Активное состояние textarea */\n.textarea--akte.active {\n  background-color: #141414;\n}\n\n/* Стили для disabled textarea */\ntextarea[disabled] {\n  color: #ffffff;\n}\n\n/* Стили для слайдера */\n.swiper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.radioText {\n  font-size: 18px !important;\n}\n\n.swiper-slide {\n  text-align: center;\n  font-size: 18px;\n}\n\n.swiper-pagination {\n  position: absolute;\n  bottom: 20px; /* Вместо margin-top используем bottom для более гибкой настройки */\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.swiper-pagination-bullet-active {\n  background-color: rgb(0, 183, 255);\n}\n\n/* Стили для slick */\n.slick-dots {\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
